import React from "react";
import TopNavigation from "./component/NavComponents/TopNavigation";
import SignIn from "./Pages/AuthPages/SignIn";
import SignUp from "./Pages/AuthPages/SignUp";
import AuthorizedRoute from "./component/AuthorizedRoute";
import Portfolio from "./Pages/Portfolio/Portfolio";
import BrokerPage from "./Pages/Broker";
import Funds from "./Pages/Funds";
import Strategies from "./Pages/Strategies";
import Custodian from "./Pages/Custodian";
import TradeBlotter from "./Pages/TradeBlotter";
import PerformanceDashboard from "./Pages/PerformanceDashboard/PerformanceDashboard";
import { Routes, Route, Navigate } from "react-router-dom";
import FundAllocator from "./Pages/FundAllocator/FundAllocator";
import Signals from "./Pages/Signals";
import Rebalancer from "./Pages/Rebalancer/Rebalancer";
import Accounting from "./Pages/Accounting";
import ForgotUserPassword from "./Pages/AuthPages/ForgotUserPassword";
import ResetUserPassword from "./Pages/AuthPages/ResetUserPassword";
import ResetPasswordOTP from "./Pages/AuthPages/ResetPasswordOTP";
import SecurityMaster from "./Pages/SecurityMaster";
import ReportsPage from "./Pages/Reports";
import HistoricalReports from "./Pages/Reports/HistoricalReports";
import Positions from "./Pages/Positions";
import FundsBlacklist from "./Pages/FundsBlacklist";
import BoxedPositionsTable from "./Pages/BoxedPositions";
// Define a configuration array for routesf
const routesConfig = [
  { path: '/portfolio', component: Portfolio },
  { path: '/portfolio/:fundName', component: Portfolio },
  { path: '/portfolio/:fundName/:strategyName', component: Portfolio },
  { path: '/funds', component: Funds },
  { path: '/strategies', component: Strategies },
  { path: '/broker', component: BrokerPage },
  { path: '/custodian', component: Custodian },
  { path: '/security', component: SecurityMaster },
  { path: '/funds-blacklist', component: FundsBlacklist },
  { path: '/reports', component: ReportsPage },
  { path: '/historical-reports', component: HistoricalReports },
  { path: '/positions', component: Positions },
  { path: '/boxed-positions', component: BoxedPositionsTable },
  { path: '/tradesV2', component: TradeBlotter },
  { path: '/fundAllocator', component: FundAllocator },
  { path: '/signals', component: Signals },
  { path: '/rebalancer', component: Rebalancer },
  { path: '/accounting', component: Accounting },
  { path: '/vantage', component: PerformanceDashboard },
];

// Helper function to render routes
const renderRoutes = (routes) => {
  return routes.map(({ path, component: Component }) => (
    <Route
      key={path}
      path={path}
      element={
        <AuthorizedRoute>
          <Component />
        </AuthorizedRoute>
      }
    />
  ));
};

function MainRoutes(props) {
  const hasAuth = props.token;
  
  return (
    <>
      {!hasAuth ? (
        <>
          <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/login" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot" element={<ForgotUserPassword />} />
            <Route path="/resetPass" element={<ResetUserPassword />} />
            <Route path="/reset-otp" element={<ResetPasswordOTP />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </>
      ) : (
        <>
          <div className="app">
            <TopNavigation />
            <main className="content">
              {props.managers && props.managers.length > 0 ? (
                <>
                  <Routes>
                    {renderRoutes(routesConfig)}
                    <Route path="*" element={<Navigate to="/vantage" replace />} />
                  </Routes>
                </>
              ) : (
                <>
                  <Routes>
                    <Route path="/" element={<Navigate to="/vantage" replace />} />
                    <Route path="/login" element={<Navigate to="/vantage" replace />} />
                    {renderRoutes(routesConfig.filter(route => ['/portfolio', '/signals', '/strategies', '/vantage'].includes(route.path)))}
                    <Route path="*" element={<Navigate to="/vantage" replace />} />
                  </Routes>
                </>
              )}
            </main>
          </div>
        </>
      )}
    </>
  );
}

export default MainRoutes;
